import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { AuthService } from 'app/providers/bridge-api/auth.service';
import { GroupService } from 'app/providers/semantria-api/group.service';
import { EnableClassTelemetry } from 'app/services/otel.service';

@EnableClassTelemetry()
@Injectable()
export class GroupRouteGuardService {
  constructor(
    private groupService: GroupService,
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean> {
    const groupId = route.paramMap.get('groupId');
    if (!groupId) {
      // this should only be applied to routes that have a groupId, but just in case-
      return Promise.resolve(true);
    }
    if (groupId.length !== 8) {
      this.router.navigateByUrl('not-found', { skipLocationChange: true });
      return Promise.resolve(false);
    }
    return this.groupService.refreshAndSelectActiveGroup(groupId);
  }
}
